import React, {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useState,
} from "react"

//Påbörjad klass för att nå data globalt, wrappar runt den delen av appen som ska kunna använda datan

//just nu blir problem att fetch från localstorage om kakor ej accepteras

const API_URL = "/api/data"
const DataContext = createContext(undefined)

export const DataContextProvider = ({ children }) => {
    const [data, setData] = useState([])

    const hasExpired = (fetchDay) => {
        if (!fetchDay) return true
        const today = new Date().getDate().toString()
        return fetchDay !== today
    }

    const fetchData = useCallback(async () => {
        try {
            const storedData = localStorage.getItem("companyData")
            const storedFetchDay = localStorage.getItem("fetchDay")

            if (storedData && !hasExpired(storedFetchDay)) {
                const companyData = JSON.parse(storedData)
                const dataFix = Array.isArray(companyData)
                    ? companyData
                    : companyData.data
                setData(dataFix)
                return
            }

            const res = await fetch(API_URL)
            const companyData = await res.json()

            const dataFix = Array.isArray(companyData)
                ? companyData
                : companyData.data
            setData(dataFix)
            localStorage.setItem("companyData", JSON.stringify(companyData))
            localStorage.setItem("fetchDay", new Date().getDate().toString())
        } catch (error) {
            console.error("Could not set data : " + error)
        }
    }, [])

    useEffect(() => {
        fetchData()
    }, [fetchData])

    return (
        <DataContext.Provider value={{ data, fetchData }}>
            {children}
        </DataContext.Provider>
    )
}

export const useData = () => {
    const context = useContext(DataContext)
    if (context === undefined)
        throw new Error("useData must be used within a DataContextProvider")
    return context
}
